import {
  Scale,
  ClipboardCheck,
  Dna,
  Radio,
  Tag,
  Smartphone,
} from "lucide-react";

const features = [
  {
    icon: Scale,
    title: "Live Weight (LWT)",
    desc: "Capture weights in real time with clean session tracking — no double-keying, no lost rows.",
  },
  {
    icon: ClipboardCheck,
    title: "Body Condition Score",
    desc: "Record BCS as you move through mobs. Preset scores, fast tap entry, full session history.",
  },
  {
    icon: Dna,
    title: "DNA Sampling",
    desc: "Lock the right sample to the right animal at the point of capture — no mismatches downstream.",
  },
  {
    icon: Radio,
    title: "Herd Reads",
    desc: "Scan and verify animal IDs instantly. Works with EID readers or manual entry — your call.",
  },
  {
    icon: Tag,
    title: "Tag Updates",
    desc: "Replace and update animal IDs accurately. Clean, structured fields — no re-typing into another system.",
  },
  {
    icon: Smartphone,
    title: "Mobile First Workflow",
    desc: "Built to run from a phone in the yard. No tablets, no laptops, no extra hardware required.",
  },
];

export default function FeaturesSection() {
  return (
    <section
      id="features"
      data-testid="features-section"
      className="bg-[#F9F8F6] py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="inline-block text-xs font-bold tracking-[0.2em] uppercase text-[#D96C32]">
            The Solution
          </span>
          <h2
            data-testid="features-headline"
            className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-[#1A1D1A] leading-tight"
          >
            One simple app for all livestock recording tasks.
          </h2>
          <p className="mt-5 text-lg text-[#4A4F4A] leading-relaxed">
            Arvo brings everything into a single workflow so you can capture,
            verify, and report while you work — not after.
          </p>
        </div>

        <div className="mt-10 sm:mt-14 grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-5">
          {features.map((f) => {
            const Icon = f.icon;
            return (
              <div
                key={f.title}
                data-testid={`feature-${f.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group bg-white border border-[#D5D1C8] rounded-md p-4 sm:p-7 shadow-sm hover:shadow-md hover:border-[#2D4A22] hover:-translate-y-0.5 transition-all"
              >
                <div className="inline-flex w-10 h-10 sm:w-14 sm:h-14 items-center justify-center rounded-md bg-[#2D4A22] text-white">
                  <Icon className="w-5 h-5 sm:w-7 sm:h-7" strokeWidth={2} />
                </div>
                <h3 className="mt-4 sm:mt-6 font-display font-bold text-base sm:text-xl text-[#1A1D1A]">
                  {f.title}
                </h3>
                <p className="mt-1.5 sm:mt-3 text-sm sm:text-base text-[#4A4F4A] leading-relaxed">
                  {f.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
